// src/pages/Iletisim.js
import React from 'react';
import './Iletisim.css';

const Iletisim = () => {
  return (
    <div className="iletisim-sayfa-wrapper">
      <h1 className="sayfa-baslik">📍 İletişim Bilgilerimiz</h1>
      <p className="sayfa-aciklama">
        Aşağıda yer alan iletişim bilgilerimizden bizimle dilediğiniz zaman iletişime geçebilirsiniz.
      </p>

      <div className="iletisim-kutu">
        <div className="iletisim-detaylar">
          <p><strong>🏢 Adres:</strong> Yeşiloba Mah. 46205 Sk. Efer 5 Sanayi Sitesi D Blok No:17/4B, Seyhan / Adana</p>
          <p><strong>📞 Telefon:</strong> 0541 332 91 63</p>
          <p><strong>📧 E-Posta:</strong> info@airmakina.com.tr</p>
          <p><strong>⏰ Hizmet:</strong> 7/24 Teknik Destek</p>
        </div>

        <div className="harita-kapsayici buyuk-harita">
          <iframe
            title="Air Makina Konumu"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d796.6736242301108!2d35.23810096954563!3d36.993224869411634!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1528875cda607eeb%3A0x181d9471a1046360!2sAir%20makina%20imalat%20sanayi%20ve%20ticaret%20limited%20%C5%9Firketi!5e0!3m2!1str!2str!4v1748107555633!5m2!1str!2str"
            width="100%"
            height="500"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </div>
  );
};

export default Iletisim;
